import { Container, Row } from 'react-bootstrap';
import React, { useCallback } from 'react';
import CompetenciesDetail from '../shared/results/competencies-detail';

function CandidateInterviewSummary({ candidate }) {
  const displaySummary = useCallback(() => {
    if (candidate) {
      return !!candidate.interviewCompetencies?.scores;
    }

    return false;
  }, [candidate]);

  return (
    <>
      {displaySummary() && (
        <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
          <>
            <Row className="justify-content-center pt-4">Interview Summary</Row>
            <Row className="justify-content-center w-25 mx-auto pt-3">
              <hr style={{ borderTop: '2px solid' }} />
            </Row>
            <Row className="w-100 mx-auto pt-1">
              <div>
                This section of the report is a summary of the Hutrics Conducted Structured Interview. It is designed to
                assess the candidate’s performance on key competencies as part of the overall hiring process. This
                information should be considered as a separate step (i.e., in addition to the predictive summary above)
                as part of the comprehensive hiring process.
              </div>
            </Row>
          </>
          <CompetenciesDetail candidate={candidate} />
        </Container>
      )}
    </>
  );
}

export default CandidateInterviewSummary;
